// extracted by mini-css-extract-plugin
export default {"container":"nba-z","tab":"oba-z","selected":"pba-z"};